import { Observable, of } from 'rxjs/index';
import Event from '../../core/Event';
import { ofType } from 'redux-observable';
import { catchError, map, mergeMap } from 'rxjs/internal/operators';
import { default as CognitoUserAuthenticator, UserSessionDetails } from './CognitoUserAuthenticator';
import UserAuthenticationSucceed from '../events/UserAuthenticationSucceed';
import ApplicationInitialized from '../../core/events/ApplicationInitialized';
import UserAuthenticationFailed from '../events/UserAuthenticationFailed';

export default (event$: Observable<Event>): Observable<Event> =>
    event$.pipe(
        ofType(ApplicationInitialized.type),
        mergeMap(() => {
            return CognitoUserAuthenticator.getLocalUser().pipe(
                map((sessionDetails: UserSessionDetails) => {
                    return new UserAuthenticationSucceed(sessionDetails);
                }),
                catchError((message: string) => {
                    return of(new UserAuthenticationFailed(message));
                })
            );
        })
    );



// WEBPACK FOOTER //
// ./src/application/user/epic/getUserSession.ts